import { useAuth } from '@/features/authentication/hooks/auth';
import Link from 'next/link';
import React from 'react';

function SidebarAction() {
  const { user } = useAuth();
  const closeMobileMenu = () => {
    const menu = document.querySelector('.menu-mobile') as HTMLElement;
    const overlay = document.querySelector('.header__overlay') as HTMLElement;

    if (menu && overlay) {
      menu.classList.remove('active');
      overlay.classList.remove('active');
    }
  };
  return (
    <div className="sidebar-login-btn d-xl-none">
      {user ? (
        <div className="d-flex flex-wrap align-items-center justify-content-center gap-3 pt-5 px-2">
          <Link
            href="/account"
            className="trk-btn trk-btn--md trk-btn--primary w-100"
            onClick={closeMobileMenu}
          >
            Dashboard
          </Link>
        </div>
      ) : (
        <div className="d-flex flex-wrap align-items-center justify-content-center gap-3 pt-5">
          <Link
            href="/login"
            className="trk-btn trk-btn--md trk-btn--primary"
            onClick={closeMobileMenu}
          >
            Login
          </Link>
          <Link
            href="/register"
            className="trk-btn trk-btn--md trk-btn--primary"
            onClick={closeMobileMenu}
          >
            Register
          </Link>
        </div>
      )}
    </div>
  );
}

export default SidebarAction;
